// oxlint-disable-next-line no-restricted-imports
import { fromJS, List, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Rule } from '#utils/flags/records/Rule';
import { createRule } from '#utils/flags/records/Rule';

export type RuleExclusionSettingsProps = {
  trackEvents: boolean;
  trackEventsFallthrough: boolean;
  rules: List<Rule>;
};

export class RuleExclusionSettings extends Record<RuleExclusionSettingsProps>({
  trackEvents: false,
  trackEventsFallthrough: false,
  rules: List(),
}) {
  validate() {
    return Map();
  }
}

export function createRuleExclusionRecord(props?: CreateFunctionInput<RuleExclusionSettings>) {
  const cfg = props instanceof RuleExclusionSettings ? props : new RuleExclusionSettings(fromJS(props));
  return cfg.withMutations((c) => {
    c.update('trackEvents', (trackEvents) => trackEvents);
    c.update('trackEventsFallthrough', (trackEventsFallthrough) => trackEventsFallthrough);
    c.update('rules', (rules) => rules && rules.map(createRule));
  });
}
